import React, { useState, useEffect } from 'react'
import AssessmentWrapper from '../../AssessmentWrapper'
import { Modal } from "antd";
import Close from "../../../../resources/imgs/modal/close.svg";
import { FaChevronRight } from "react-icons/fa";
import { useRecoilValue } from 'recoil'
import { assessmentAtom } from "../../../../state/assessment";
import { addAssessment } from '../../../../services/assessment';
import Progress from "../../progress";
import HelpBtn from "../../../../resources/imgs/assessment/helpBtn.svg";

// Import all character images to determine non-selected ones
import Joey1 from "../../../../resources/imgs/assessment/characters/joey1.png"
import Karl1 from "../../../../resources/imgs/assessment/characters/karl1.png"
import Manuel1 from "../../../../resources/imgs/assessment/characters/manuel1.png"
import Pamela1 from "../../../../resources/imgs/assessment/characters/pamela1.png"
import Peter1 from "../../../../resources/imgs/assessment/characters/peter1.png"
import Reina1 from "../../../../resources/imgs/assessment/characters/reina1.png"
import Roy1 from "../../../../resources/imgs/assessment/characters/roy1.png"
import Samantha1 from "../../../../resources/imgs/assessment/characters/samantha1.png"
import Trish1 from "../../../../resources/imgs/assessment/characters/trish1.png"

// All 9 characters data
const allCharacters = [
  { img: Manuel1, name: "Manuel" },
  { img: Pamela1, name: "Pamela" },
  { img: Trish1, name: "Trish" },
  { img: Karl1, name: "Karl" },
  { img: Joey1, name: "Joey" },
  { img: Reina1, name: "Reina" },
  { img: Peter1, name: "Peter" },
  { img: Roy1, name: "Roy" },
  { img: Samantha1, name: "Samantha" }
];

// Use the compressed stranger images from public directory (only 3 needed now)
const getStrangerImage = (strangerNumber) => {
  // Map to correct file extensions for compressed images
  const extensions = {1: 'jpg', 2: 'jpg', 3: 'png'};
  return `${process.env.PUBLIC_URL}/images/strangers/Stranger%20${strangerNumber}.${extensions[strangerNumber]}`;
};

var initialRes = {
  module: 4,
  moduleKey: "face_recall",
  A_faceRecognition: []
}

// Updated Module 4-2 with cognitive scoring
function Module4_2Content({ nextPage, recordScore, cardData, handleModuleComplete }) {
  const assessment = useRecoilValue(assessmentAtom);
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const [isMyGuest, setIsMyGuest] = useState(0);
  const [initialData, setInitialData] = useState([])

  useEffect(() => {
    console.log('🔍 Module4A useEffect called with cardData:', cardData);
    
    if (!cardData || cardData.length === 0) {
      console.log('⚠️ Module4A: No cardData available yet');
      return;
    }
    
    // Get the 6 selected characters (guests)
    let guestData = [];
    const selectedNames = [];
    for (let i = 0; i < cardData.length; i++) {
      guestData.push({
        img: cardData[i].otherImg,
        name: cardData[i].name,
        isMyGuest: 1
      });
      selectedNames.push(cardData[i].name);
    }
    
    // Get the 3 non-selected characters
    const nonSelectedCharacters = allCharacters.filter(
      char => !selectedNames.includes(char.name)
    );
    
    // Use only 3 non-selected characters as non-guests
    const nonGuestCharacters = shuffleArray(nonSelectedCharacters).slice(0, 3).map(char => ({
      img: char.img,
      name: char.name,
      isMyGuest: 2
    }));
    
    // Add 3 stranger images as additional non-guests
    const strangerData = [
      { img: getStrangerImage(1), name: "Stranger1", isMyGuest: 2 },
      { img: getStrangerImage(2), name: "Stranger2", isMyGuest: 2 },
      { img: getStrangerImage(3), name: "Stranger3", isMyGuest: 2 }
    ];

    // Combine all: 6 guests + 3 non-selected characters + 3 strangers = 12 total
    const allData = shuffleArray([...guestData, ...nonGuestCharacters, ...strangerData]);
    
    console.log('🔍 Module4A: Generated data:', {
      guests: guestData.map(d => d.name),
      nonSelectedCharacters: nonGuestCharacters.map(d => d.name),
      strangers: strangerData.map(d => d.name),
      total: allData.length
    });
    
    setInitialData(allData);
  }, [cardData])

  // Function to shuffle an array randomly (Fisher-Yates algorithm)
  const shuffleArray = (array) => {
    const arr = [...array];
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  };

  const showModal = () => {
    setOpen(true);
  };

  const hideModal = () => {
    setOpen(false);
  };

  const nextStep = async () => {
    const isCorrect = initialData[index].isMyGuest === isMyGuest;
    
    // Record the score (difficulty 2 for Module 4A, 1 point per correct answer)
    if (recordScore) {
      recordScore(isCorrect, {
        moduleKey: "face_recall",
        questionNumber: index + 1,
        totalQuestions: 12,
        userAnswer: isMyGuest === 1 ? "Guest at my table" : "Not my guest", 
        correctAnswer: initialData[index].isMyGuest === 1 ? "Guest at my table" : "Not my guest",
        imageType: initialData[index].isMyGuest === 1 ? "guest" : "stranger"
      });
    }
    
    if (index < 11) {
      initialRes.A_faceRecognition.push({
        imageId: `${index + 1}.png`,
        userAnswer: isMyGuest === 1 ? true : false,
        isCorrect: isCorrect
      })
      console.log(initialRes);
      setIndex(index + 1);
      setIsMyGuest(0);
    } else {
      // Final question - record it and complete module
      initialRes.A_faceRecognition.push({
        imageId: `${index + 1}.png`,
        userAnswer: isMyGuest === 1 ? true : false,
        isCorrect: isCorrect
      })
      
      // Module complete
      if (handleModuleComplete) {
        const correctAnswers = initialRes.A_faceRecognition.filter(answer => answer.isCorrect).length;
        handleModuleComplete({
          moduleKey: "face_recall",
          totalQuestions: 12,
          correctAnswers,
          percentageScore: (correctAnswers / 12) * 100,
          difficulty: 1
        });
      } else {
        // Original behavior for non-scoring mode
        // Module 4A completed - original mode
        console.log('Module 4A completed', initialRes);
        // Delay nextPage to allow score popup to display
        setTimeout(() => {
          nextPage();
        }, 2500);
      }
    }
  }

  console.log('🔍 Module4A render:', { 
    initialDataLength: initialData.length, 
    index, 
    isMyGuest, 
    cardDataLength: cardData?.length || 0,
    currentImage: initialData[index]?.img 
  });

  // Show loading state if no data yet
  if (!initialData || initialData.length === 0) {
    return (
      <div className="module1-main">
        <div className="module1-wrap">
          <Progress number="04." percent={1 / 2} />
          <div className="module1-content-wrap">
            <div className="module1-logo">Module 4A</div>
            <div className="module1-body">
              <div className="module1-title">Loading face recognition test...</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="module1-main">
      <div className="module1-wrap">
        <Progress number="04." percent={1 / 2} />
        <div className="module1-content-wrap">
          <div className="module1-logo">Module 4</div>
          <div className="module1-body">
            <div className="module1-title">
              Identifying guests from the crowd
            </div>
          </div>
        </div>
      </div>

      <div className="img-container">
        <img
          className="module1-content2 module1-woman-img"
          src={initialData.length && initialData[index].img}
          style={{
            width: '200px',
            height: '200px', 
            objectFit: 'cover',
            borderRadius: '10px',
            boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
          }}
          alt="Person to identify"
        />
      </div>
      <div className="module1-categories"></div>
      <div className="module1-dishes module1-dishes2 module3-dishes">
        <div
          className="module1-dish module4-dish"
          onClick={() => setIsMyGuest(1)}
          style={{ background: isMyGuest === 1 ? "#F277C6" : "" }}
        >
          Guest at my table
        </div>
        <div
          className="module1-dish module4-dish"
          onClick={() => setIsMyGuest(2)}
          style={{ background: isMyGuest === 2 ? "#F277C6" : "" }}
        >
          Not my guest
        </div>
      </div>

      <div className='next-btn-group'>
        <div className='help-btn-group'>
          <div className='help-btn-effect1'></div>
          <div className='help-btn-effect2'></div>
          <img src={HelpBtn} onClick={() => showModal()} />
          <div className='help-content'>Do you need help?</div>
        </div>

        {isMyGuest !== 0 && (
          <div
            className="assessment-next-btn"
            onClick={() => { nextStep() }}
          >
            Next{" "}
            <div
              style={{
                paddingTop: "5px",
                display: "inline-block",
              }}
            >
              <FaChevronRight color="white" size={16} />
            </div>
          </div>
        )}
      </div>

      <Modal
        open={open}
        onOk={() => showModal()}
        onCancel={() => hideModal()}
        closeIcon={<img src={Close}></img>}
        footer={null}
      >
        <div className="direction-modal-container">
          <div className='direction-modal-title'>Directions</div>
          <div className='direction-modal-content'>
            During dinner, all of your guests realize they need to use the bathroom at the same time. Because each guest has forgotten the location of their table, your job is to point them in the right direction.  To do so, you need to identify whether the guest you encounter is one of your guests  or is sitting at another table.  Click “Next” to test your ability to recognize faces!
          </div>
        </div>
      </Modal>
    </div>
  )
}

// Scored wrapper for Module 4A
export const ScoredModule4_2 = (props) => (
  <AssessmentWrapper 
    moduleType="4A" 
    isAdaptive={false}
    onModuleComplete={props.onModuleComplete}
  >
    <Module4_2Content {...props} />
  </AssessmentWrapper>
);

// Keep original export for backwards compatibility
export default function Index(props) {
  return <Module4_2Content {...props} />;
}
